import {
  Avatar,
  Divider,
  Grid,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { IMedication } from 'API';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlineWarningIcon, RedWarning } from 'Images';
import { Fragment } from 'react';
import { expiredDays } from 'Utils';

interface IExpiredMedications {
  expiredMedications: IMedication[];
}
export const ExpiredMedications = (props: IExpiredMedications) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  const listTitlesStyle = {
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '25px',
  };

  return isDesktop ? (
    <>
      <Grid container mb={1} role='rowgroup'>
        <Grid item xs={3}>
          <Typography sx={listTitlesStyle} role='columnheader'>
            {dictionary.nameOfTheMedication}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography sx={listTitlesStyle} role='columnheader'>
            {dictionary.currentPrescriptionValidity}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography sx={listTitlesStyle} role='columnheader'>
            {dictionary.notes}
          </Typography>
        </Grid>
      </Grid>
      <List sx={{ background: 'white' }} disablePadding>
        {props.expiredMedications.map((medication, i) => (
          <Fragment key={i}>
            <ListItem
              key={medication.medicatioN_CODE}
              sx={{ height: '54px', padding: '8px' }}
              tabIndex={0}
              role='row'
            >
              <Grid container>
                <Grid item xs={3}>
                  <Typography variant='body4' role='cell'>
                    {medication.medicatioN_NAME}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='body6' role='cell'>
                    {format(new Date(medication.nextrefreshdate), 'dd/MM/yyyy')}
                  </Typography>
                </Grid>
                <Grid item container alignItems='center' xs={6} spacing={1}>
                  <Grid item>
                    <Avatar
                      src={RedWarning}
                      alt={generalDictionary.warning}
                      sx={{ width: '18px', height: '18px' }}
                    />
                  </Grid>
                  <Grid item>
                    {expiredDays(new Date(medication.nextrefreshdate))
                      .isFuture ? (
                      <Typography variant='body6' role='cell'>
                        {`${dictionary.leftMore} `}
                        <Typography variant='body6' component='span'>
                          {
                            expiredDays(new Date(medication.nextrefreshdate))
                              .days
                          }
                        </Typography>
                        {` ${dictionary.days}`}
                      </Typography>
                    ) : (
                      <>
                        <Typography
                          variant='body6'
                          color={'#E12D2D'}
                          role='cell'
                        >
                          {`${dictionary.expired}`}
                          <Typography
                            variant='body6'
                            color={'#E12D2D'}
                            component='span'
                          >
                            {` ${dictionary.numberOfDaysAgo(
                              expiredDays(new Date(medication.nextrefreshdate))
                                .days
                            )}`}
                          </Typography>
                        </Typography>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>
          </Fragment>
        ))}
      </List>
    </>
  ) : (
    <>
      <List sx={{ background: 'white' }} disablePadding>
        {props.expiredMedications.map((medication, i) => (
          <Fragment key={i}>
            <ListItem key={medication.medicatioN_CODE} tabIndex={0}>
              <Grid container>
                <Grid item xs={12} mb={2}>
                  <Grid item xs={12}>
                    <Typography variant='body3'>
                      {dictionary.nameOfTheMedication}
                    </Typography>
                  </Grid>
                  <Typography>{medication.medicatioN_NAME}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid item xs={12} mb={'4px'}>
                    <Typography variant='body3'>
                      {dictionary.currentPrescriptionValidity}
                    </Typography>
                  </Grid>
                  <Typography variant='body2'>
                    {format(new Date(medication.nextrefreshdate), 'dd/MM/yyyy')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  alignItems='center'
                  xs={12}
                  mt={1}
                  spacing={1}
                >
                  <Grid item>
                    <Avatar
                      src={
                        expiredDays(new Date(medication.nextrefreshdate))
                          .isFuture
                          ? PurpleOutlineWarningIcon
                          : RedWarning
                      }
                      alt={generalDictionary.warning}
                      sx={{ width: '18px', height: '18px' }}
                    />
                  </Grid>
                  <Grid item pb={'2px'}>
                    {expiredDays(new Date(medication.nextrefreshdate))
                      .isFuture ? (
                      <Typography variant='body6'>
                        {`${dictionary.leftMore} `}
                        <Typography variant='body6' component='span'>
                          {
                            expiredDays(new Date(medication.nextrefreshdate))
                              .days
                          }
                        </Typography>
                        {` ${dictionary.days}`}
                      </Typography>
                    ) : (
                      <>
                        <Typography variant='body6' color={'#E12D2D'}>
                          {`${dictionary.expired}`}
                          <Typography
                            variant='body6'
                            color={'#E12D2D'}
                            component='span'
                          >
                            {` ${dictionary.numberOfDaysAgo(
                              expiredDays(new Date(medication.nextrefreshdate))
                                .days
                            )}`}
                          </Typography>
                        </Typography>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </ListItem>

            <Divider
              aria-hidden={'true'}
              orientation={'horizontal'}
              sx={{ borderColor: 'primary.shade_200', m: '20px 0' }}
            />
          </Fragment>
        ))}
      </List>
    </>
  );
};
